import {combineReducers, CombinedState, AnyAction, Reducer} from 'redux'
import auth, {AuthState} from './slices/auth'
import base, {BaseState} from './slices/base'
import locale, {LocaleState} from './slices/locale/localeSlice'
import theme, {ThemeState} from './slices/theme/themeSlice'
// import RtkQueryService from '@/services/RtkQueryService'

export type RootState = CombinedState<{
    auth: CombinedState<AuthState>
    base: CombinedState<BaseState>
    locale: LocaleState
    theme: ThemeState
    /* eslint-disable @typescript-eslint/no-explicit-any */
    // [RtkQueryService.reducerPath]: any
}>

export interface AsyncReducers {
    [key: string]: Reducer<any, AnyAction>
}

const staticReducers = {
    auth,
    base,
    locale,
    theme,
    // [RtkQueryService.reducerPath]: RtkQueryService.reducer,
}

const rootReducer =
    (asyncReducers?: AsyncReducers) =>
        (state: RootState, action: AnyAction) => {
            if (action.type == 'setRootState') {
                let newState = action.payload;
                for (let key in newState) {
                    if (["auth", "base", "locale", "rtkApi", "theme", "_persist"].includes(key))
                        delete newState[key];
                }
                state = {
                    ...state,
                    ...newState
                }
            } else if (action.type == 'clearRootState') {
                for (let key in state) {
                    if (!["auth", "base", "locale", "rtkApi", "theme", "_persist"].includes(key))
                        delete state[key];
                }
            }

            const combinedReducer = combineReducers({
                ...staticReducers,
                // async: combineReducers({...asyncReducers}),
                ...asyncReducers,
            })

            return combinedReducer(state, action)
        }

export const setRootState = (payload: Partial<RootState>): AnyAction => ({
    type: "setRootState",
    payload,
});

export const clearRootState = (payload: Partial<RootState>): AnyAction => ({
    type: "clearRootState",
    payload,
});

export default rootReducer
